import { cn } from "@/lib/utils";
import { forwardRef, HTMLAttributes } from "react";

export const Thumbnail = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      "border-gray-200 border rounded-xl p-3 size-fit flex items-center justify-center",
      className,
    )}
    {...props}
  />
));

Thumbnail.displayName = "Thumbnail";
